/**
 * @voltxampere/ui — OPA2134 high-end audio op-amp variant (Sprint 39-3)
 *
 * Burr-Brown OPA2134 dual op-amp. 1 V/μV open-loop gain (ten times
 * NE5532), 8 MHz GBW, 20 V/μs slew, 0.00008 % THD at 1 kHz. Premium
 * audio applications (preamps, headphone amps, audiophile gear).
 *
 * Reference: TI SBOS022B.
 *
 * Engine zero-diff invariant honored.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { opAmp } from "../op-amp.js";
export const opampOpa2134 = {
    id: "opa2134",
    nameTr: "OPA2134 (Yüksek-Sınıf Ses, DIP-8)",
    nameEn: "OPA2134 (High-End Audio, DIP-8)",
    shortcut: "O",
    category: "active",
    viewBox: opAmp.viewBox,
    terminals: opAmp.terminals,
    defaultLabel: "U",
    defaultValue: "OPA2134",
    schemaType: "opamp",
    defaultParams: {
        openLoopGain: 1e6,
        saturationVoltage: 13,
        gainBandwidthProduct: 8e6,
    },
    renderSVG: () => opAmp.renderSVG(),
};
//# sourceMappingURL=opamp-opa2134.js.map